<div class="list-container" [ngClass]="{ 'with-shadow': withShadow}">
  <div class="header-container" *ngIf="header">
    <div class="header-text">
      <h4 class="main-header">{{header}}</h4>
      <div textSmall *ngIf="subHeader" class="subheader">{{subHeader}}</div>
      <mat-divider class="header-divider"></mat-divider>
    </div>
  </div>
  <mat-selection-list class="pezi-list" [multiple]="false" [hideSingleSelectionIndicator]="true">
    <mat-list-option *ngFor="let item of entries" (click)="emitClick(item)"
                     [disabled]="item.disabled || globalDisabled" class="list-row">
      <div class="row-content">
        <mat-icon matListItemIcon *ngIf="item.infoText" (click)="showInfoText(item.infoText)" class="info-icon">info
        </mat-icon>
        <ng-container>
          <div matListItemIcon class="image-list-icon" *ngIf="item.imageURL" [ngStyle]="{
              'background-image': 'url(' + item.imageURL + '), url('+item.fallbackURL+')'
            }"></div>
          <div matListItemIcon class="image-list-icon" *ngIf="!item.imageURL && item.fallbackURL" [ngStyle]="{
              'background-image': 'url(' + item.fallbackURL + ')'
            }"></div>
          <div *ngIf="!item.imageURL && item.imageIcon">
            <mat-icon matListItemIcon class="list-icon"  [ngClass]="{'success': item.imageIconColor && item.imageIconColor === 'success',
            'error': item.imageIconColor && item.imageIconColor === 'error'}" matTooltip="{{item.imageIconTooltip}}"
                      [matTooltipDisabled]="!item.imageIconTooltip">{{ item.imageIcon }}
            </mat-icon>
          </div>
        </ng-container>
        <div class="text-with-status">
          <div class="multi-line-text" *ngIf="!isSingleLineList">
            <div textSmall>{{item.text}}</div>
            <div textSmall>{{item.subtext ? item.subtext : '-'}}</div>
            <div *ngIf="item.additionalText" textSmall class="additional-text">{{item.additionalText}}</div>
          </div>
          <div *ngIf="isSingleLineList">{{item.text}}</div>
          <div *ngIf="item.onlineStatus" class="left-margin">
            <div class="material-icons pointer-cursor status-color"
                 [ngClass]="{'status1': item.onlineStatus.status === '1',
                 'status2': item.onlineStatus.status === '2',
                 'status3': item.onlineStatus.status === '3',
                 'status4': item.onlineStatus.status === '4',
                 'status5': item.onlineStatus.status === '5'}"
                 [title]="(item.onlineStatus.message ? item.onlineStatus.message : 'Kein Status verfügbar')"
            >fiber_manual_record
            </div>
          </div>
        </div>
      </div>
    </mat-list-option>
    <div *ngIf="!entries || entries.length === 0" class="list-nodata">
      <mat-icon>{{nodataIcon}}</mat-icon>
      <div class="no-data-text">{{nodataText}}</div>
    </div>
  </mat-selection-list>
</div>
